import { TableBody, TableCell, TableRow, TableRowProps } from "@mui/material"
import { MutableRefObject, SyntheticEvent, useEffect, useRef, useState } from "react"
import { IGTableProps, TRenderData } from "./GTableConsts"
import GWidgetHelpers from "../widgets/IGWidget"

export function GTableCell<T>(props:IGTableProps<T>&{row:T,col:string}) {
    const {row,col} = props
    const renderer = props.bodyCell 
        ? props.bodyCell 
        : (row:T, col:string, data:TRenderData|undefined) => props.value!(row, col)
    const customProps = props.bodyCellProps ? props.bodyCellProps(row, col, props.data) : null
    return <TableCell key={col} {...customProps}>{renderer(row, col, props.data)}</TableCell>
}

export function useGTableRow<T>(props:IGTableProps<T>&{row:T}, ref:MutableRefObject<any>) {
    const [hover,setHover] = useState<boolean>(false)
    const onEnter = (e:SyntheticEvent) => setHover(true)
    const onLeave = (e:SyntheticEvent) => setHover(false)

    const cells = props.cols.map(col => <GTableCell {...props} row={props.row} col={col} key={col}/>)
    const rowProps : TableRowProps = {onMouseEnter:onEnter, onMouseLeave:onLeave}
    const customProps = props.bodyRowProps ? props.bodyRowProps(props.row, props.data, ref) : {}
    customProps.className = GWidgetHelpers.toString(GWidgetHelpers.join({hover}, customProps.classNames))
    return {rowProps,customProps,cells}
}

export function GTableRow<T>(props:IGTableProps<T>&{row:T}) {
    const ref = useRef<any>()
    const {rowProps,customProps,cells} = useGTableRow(props, ref)
    useEffect(() => {
        props.onRowMount?.(props.row, ref)
        return () => props.onRowUnmount?.(props.row, ref)
    }, [props.row])
    return <TableRow {...rowProps} {...customProps} ref={ref}>{cells}</TableRow>
}

export default function GTableBody<T>(props:IGTableProps<T>){
    const keygen = props.rowKey ? props.rowKey : (row:T) => JSON.stringify(row)
    const rows : JSX.Element[] = props.rows.map((row:T,i) => {
        const key = keygen(row)
        return <GTableRow {...props} row={row} key={key}/>
    })
    return <TableBody>{rows}</TableBody>
}